import { render, staticRenderFns } from "./CompanyYearList.vue?vue&type=template&id=6d9f93b5"
import script from "./CompanyYearList.vue?vue&type=script&lang=ts"
export * from "./CompanyYearList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports